import { IAction } from "../../../../interface/action.interface";
import { IListDto } from "../../../../interface/dto/list.dto";

export enum ListToTrackSearchActionTypes {
    LIST_TO_TRACK_SEARCH_GET = "LIST_TO_TRACK_SEARCH_GET",
    LIST_TO_TRACK_SEARCH_GET_SUCCESS = "LIST_TO_TRACK_SEARCH_GET_SUCCESS",
    LIST_TO_TRACK_SEARCH_GET_ERROR = "LIST_TO_TRACK_SEARCH_GET_ERROR",
    LIST_TO_TRACK_SELECT = "LIST_TO_TRACK_SELECT",
}

export interface ITrackListSearchGetAction extends IAction {
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET;
    payload: {
        filter: string;
    };
}

export interface ITrackListSearchGetSuccessAction extends IAction {
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET_SUCCESS;
    payload: {
        lists: Array<IListDto>;
    };
}

export interface ITrackListSearchGetErrorAction extends IAction {
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET_ERROR;
    payload: {
        error: string;
    };
}

export interface ITrackListSelectAction extends IAction {
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SELECT;
    payload: {
        selectedList: IListDto | undefined;
    };
}

export const trackListSearchAction = (
    filter: string,
): ITrackListSearchGetAction => ({
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET,
    payload: { filter },
});

export const trackListSearchSuccessAction = (
    lists: Array<IListDto>,
): ITrackListSearchGetSuccessAction => ({
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET_SUCCESS,
    payload: { lists },
});

export const trackListSearchErrorAction = (error: string) => ({
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SEARCH_GET_ERROR,
    payload: { error },
});

export const trackListSelectAction = (
    selectedList: IListDto | undefined,
): ITrackListSelectAction => ({
    type: ListToTrackSearchActionTypes.LIST_TO_TRACK_SELECT,
    payload: { selectedList },
});

export type IListToTrackActions =
    | ITrackListSearchGetAction
    | ITrackListSearchGetSuccessAction
    | ITrackListSearchGetErrorAction
    | ITrackListSelectAction;
